import { Component, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-change-state',
  templateUrl: './change-state.component.html',
  styleUrls: ['./change-state.component.scss']
})
export class ChangeStateComponent implements OnInit {
  states: any[]=[];
  statesColorsList: any[]=[];
  loader: boolean = false;

  constructor(
    private adminservice: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChangeStateComponent>,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.statesColors();
    this.getStates();
  }

  statesColors(){
    this.adminservice.getStates().subscribe(
      (response)=>{
        this.statesColorsList = response;
      }
    );
  }

  getStates(){
    this.adminservice.getStatesClient().subscribe(
      (response)=>{
        if (response.rtn) {
          this.states = response.result;
          this.states.forEach((element:any)=>{
            element.selected = false;
            element.color = this.getColor(element.descripcion);
          });
        }
      }
    );
  }

  changeStateClient(state:any){
    this.states.forEach((element:any)=>element.selected = false);
    state.selected = true;
  }

  saveState(){
    const stateFind = this.states.find((element:any)=>element.selected);
    if (!stateFind) {
      return
    }

    const request = {
      cliente_id: this.data.id,
      estado_id: stateFind.id
    }
    this.loader = true;
    this.adminservice.changeStateClient(request).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn) {
          this.dialogRef.close(stateFind.descripcion);
          this.dialog.open(AlertComponent,{
            width: '776px',
            disableClose: true,
            data: {
              type: 'success',
              title: 'Operación exitosa',
              description: 'Se ha cambiado el estado del cliente correctamente.',
              textButton: 'Entendido'
            }
          });
        }
      }
    );
  }

  getColor(state:string):string{
    return this.statesColorsList.find((element)=> element.label == state).class;
  }

}
